import {GET_COMMUNITY_TYPE } from '../../actiontypes'

export const CommunityFetchReducer = (selectedCommunity) => {
    return (dispatch) => {
            dispatch({ type: GET_COMMUNITY_TYPE, payload: selectedCommunity});
    }      
};